import React from 'react';

import { StyleProp, View, ViewStyle } from 'react-native';

import { useTranslation } from 'react-i18next';

import { UnsubscribedIcon } from 'assets/images';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import styles from 'components/ContentMarkerIcons/SubscribeMarker/SubscribeMarker.styles';

type Props = {
    size?: number;
    style?: StyleProp<ViewStyle>;
    subscribeTestID?: string;
    tabIndex?: number;
};

const {
    ACCESSIBILITY: {
        DETAIL_PAGE: { ACCESSIBILITY_ICON_SHOPPING_CART },
    },
} = LANGUAGE_KEYS;

const SubscribeIcon = ({
    size = 24,
    style,
    subscribeTestID,
    tabIndex,
}: Props) => {
    const { t } = useTranslation();

    return (
        <View
            style={[styles.marker, style]}
            accessibilityLabel={t(ACCESSIBILITY_ICON_SHOPPING_CART)}
            accessibilityRole="image"
            accessible
            // @ts-ignore
            tabIndex={tabIndex}
        >
            <UnsubscribedIcon
                testID={subscribeTestID}
                height={size}
                width={size}
                fill="white"
            />
        </View>
    );
};

export default SubscribeIcon;
